<template>
    <div class="card card-custom card-stretch gutter-b d-flex">
        <div class="form_forgot-password">
            <el-container>
                <el-main>
                    <div class="header-form__forgot-password">
                        <div class="logo">
                            <img src="/media/logos/logo-1.png" alt="">
                        </div>
                        <div class="title">
                            <span class="text-dr" v-if="!sendMail">
                                パスワード再設定
                            </span>
                            <span class="text-dr" v-if="sendMail">
                               パスワード再設定依頼 (完了)
                            </span>
                        </div>
                    </div>
                    <div class="pl-20 pr-20 mt-3">
                        <el-card class="box-card p-30">
                            <el-form @submit.native.prevent="onSubmit" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-position="top"
                                     class="demo-ruleForm demo-form" v-if="!sendMail">
<!--                                <el-form-item prop="email">
                                    <h5>本アプリに登録したメールアドレスを入力してください。</h5>
                                    <br>
                                    <h5><b>メールアドレス</b></h5>
                                    <br>
                                    <el-input class="d-none" type="text"></el-input>
                                    <el-input  type="email" v-model="ruleForm.email"></el-input>
                                </el-form-item>-->
                                <div class="row mb-2">
                                    <div class="col-md-3">
                                        <h6><b>メールアドレス</b></h6>
                                    </div>
                                    <el-form-item prop="email" class="col-md-9">
                                        <el-input type="text" class="bg-gray-item" v-model.lazy="ruleForm.email">
                                        </el-input>
                                    </el-form-item>
                                </div>

                                <br>
<!--                                <el-form-item class="text-center">
                                    <el-button class="pl-15 pr-15 submit-form" type="primary" @click="onSubmit">送信</el-button>
                                </el-form-item>-->
                                <div class="d-flex justify-content-center mt-0">
                                    <el-button class="btn-custom" type="" @click="$router.push('login')">
                                        キャンセル
                                    </el-button>
                                    <el-button class="btn-custom" type="primary" @click="onSubmit">
                                        確定
                                    </el-button>
                                </div>
                                <input type="hidden" name="_csrf" v-model="ruleForm._csrf" />
                            </el-form>
                            <div v-if="sendMail" class="pl-20 pr-20">
                                <h5><b>パスワード再設定のメールを送信します。</b></h5>
                                <h5><b>メールに記載されたリンクをクリックして手続きを行ってください。</b></h5>
                                <br>
                                <h5>メールが届かない場合、迷惑メールフォルダーなどもご確認ください。</h5>

                                <div class="d-flex justify-content-center mt-20">
                                    <el-button class="pl-15 pr-15" type="primary" @click="$router.push('login')">ログイン画面へ</el-button>
                                </div>
                            </div>
                        </el-card>
                    </div>
                </el-main>
            </el-container>
        </div>
      <my-dialog
        v-on:submit="popup=false"
        v-bind:dialog="popup"
        :closeOnClickModal="false" width="20%" v-bind:btnOk="$t('DIALOG.BTN_OKIE_PERMISSON_DENIED')"
        :showCancelButton="false">
        <template slot="header">
          <div class="textwidget text-center">
            {{ contentPoopup }}
          </div>
        </template>
      </my-dialog>
    </div>
</template>

<script>
import apiService from "@/core/services/api.service";
import routeTenant from "@/core/services/routeTenant.service"
import { getCsrfRandom } from "@/core/services/store/auth.module";

const tenant = routeTenant.getTenant();
export default {
    name: "ForgotPassword",
    data() {
      //penđing
      /*var validateSpace  = (rule, value, callback) => {
        if (!value.toString().replace(/\s/g, '').length) {
          return callback(new Error('空白以外を入力してください。'));
        } else {
          setTimeout(() => {
            if (this.ruleForm[rule.field] !== '' && this.$refs.ruleForm) {
              this.$refs.ruleForm.validateField(rule.field);
            }
            return callback();
          }, 1000);
        }
      }*/
        return {
            ruleForm: {
                email: '',
                tenant_code:tenant,
                _csrf:''
            },
            rules: {
                // email: [
                //   {required: true, message: '必須項目に入力してください。', trigger: 'blur'},
                //   {type: 'email', message: 'メール形式を正しく入力してください。', trigger: ['blur', 'change']}
                // ]
            },
            sendMail: false,
            popup :false,
            contentPoopup:''
        }
    },
  watch: {
    "ruleForm.email": function(newData) {
      this.ruleForm.email=this.ruleForm.email.replace(/\s+/g, '');
    }
  },
  mounted() {
    const vm = this
    window.addEventListener('keyup', function(event) {
      if (event.keyCode === 13) {
        vm.onSubmit()
      }
    });
  },
  created() {
    this.ruleForm._csrf = getCsrfRandom()
  },
    methods: {
        onSubmit() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.turnOffErrorMessage('ruleForm')
                    let data = JSON.parse(JSON.stringify(this.ruleForm))
                    apiService.post(`auth/forgot-password`, data).then(data => {
                      if (data && data.data && data.data.success) {
                        this.sendMail = true
                      }else if (data.data.code = 422){
                        if (data.data && data.data.data && data.data.data.tenant_code&& data.data.data.tenant_code[0]){
                          this.popup = true
                          this.contentPoopup = data.data.data.tenant_code[0]
                        } else if (data.data && data.data.data && data.data.data.poopup_err&& data.data.data.poopup_err[0]){
                          this.popup = true
                          this.contentPoopup = data.data.data.poopup_err[0]
                        }else {
                          this.showErrorMessage(data.data.data, 'ruleForm')
                        }
                      }else {
                        this.notifyError('error server')
                      }
                    }).catch(e => {
                        this.loading = false
                        this.notifyError(e)
                    })
                }
            });
        }
    }
}
</script>

<style scoped>
    .form_forgot-password {
        width: 80%;
        margin: 0 auto;
    }
    .header-form__forgot-password .title {
      text-align: center;
      padding: 4px 0;
      font-size: 23px;
      font-weight: bold;
    }
    .header-form__forgot-password .logo {
        padding: 15px;
    }
    .text-dr{
      color: #181C32 !important;;
    }
    .font-w {
      font-weight: 600;
    }
    .submit-form{
      font-size: 18px;
      font-weight: bold;
    }
</style>
